function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import { buildRows, buildHeaders } from '../../helpers';
import { StyledTable } from './styles';
import { DragDropContext, Droppable } from '@hello-pangea/dnd';
const Table = props => {
  const {
    theme,
    selectedTheme,
    content,
    sortable,
    defaultSort,
    draggable,
    dragIcon,
    columnLayout,
    headerTextColor,
    headerBGColor,
    labelTextColor,
    labelBGColor,
    evenTextColor,
    evenBGColor,
    evenHoverTextColor,
    evenHoverBGColor,
    oddTextColor,
    oddBGColor,
    oddHoverTextColor,
    oddHoverBGColor,
    mobileSize
  } = props;
  const [ascending, setAscending] = useState(!sortable);
  const [sortedColumn, setSortedColumn] = useState(sortable && defaultSort);
  const args = {
    theme,
    selectedTheme,
    content,
    sortable,
    defaultSort,
    draggable,
    dragIcon,
    columnLayout,
    headerTextColor,
    headerBGColor,
    labelTextColor,
    labelBGColor,
    evenTextColor,
    evenBGColor,
    evenHoverTextColor,
    evenHoverBGColor,
    oddTextColor,
    oddBGColor,
    oddHoverTextColor,
    oddHoverBGColor,
    mobileSize,
    ascending,
    setAscending,
    sortedColumn,
    setSortedColumn
  };
  const handleDragEnd = result => {
    if (result.source && result.destination) {
      const {
        source: {
          index: fromIndex
        },
        destination: {
          index: toIndex
        }
      } = result;
      if (fromIndex !== toIndex) {
        const workingArr = [...content.rows];
        const [reordered] = workingArr.splice(fromIndex, 1);
        workingArr.splice(toIndex, 0, reordered);
        if (sortedColumn) setSortedColumn(null);
        draggable(workingArr);
      }
    }
  };
  return /*#__PURE__*/React.createElement(DragDropContext, {
    onDragEnd: handleDragEnd
  }, /*#__PURE__*/React.createElement(Droppable, {
    droppableId: "rows"
  }, provided => /*#__PURE__*/React.createElement(StyledTable, _extends({
    ref: provided.innerRef
  }, provided.droppableProps), buildHeaders(args), content && buildRows(args), provided.placeholder)));
};
export { Table };